// start:ng42.barrel
export * from './price-amount.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/price-amount/index.ts